export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/auth/AuthView.vue'),
        meta: {
            guestOnly: true
        },
    },
    {
        path: '',
        name: 'start',
        component: () => import('../views/auth/StartView.vue'),
        meta: {
            guestOnly: true
        },
    },
]
